import { render, staticRenderFns } from "./giftDetails.vue?vue&type=template&id=1bf1020d&scoped=true&"
import script from "./giftDetails.vue?vue&type=script&lang=js&"
export * from "./giftDetails.vue?vue&type=script&lang=js&"
import style0 from "./giftDetails.vue?vue&type=style&index=0&id=1bf1020d&prod&lang=css&"
import style1 from "./giftDetails.vue?vue&type=style&index=1&id=1bf1020d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf1020d",
  null
  
)

export default component.exports